import { observer } from 'mobx-react-lite'
import { Modal, Typography } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { useCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { SimpleFormFieldCell } from '../SimpleFormFieldCell'
import type { ConfirmExecutionModalStore } from '../../Stores/ConfirmExecutionModalStore'

const { Text } = Typography

interface Props {
    store: ConfirmExecutionModalStore
}

export const ConfirmExecutionModal = observer(({ store }: Props) => {
    const { showSuccess, showError } = useNotification()
    const crudContext = useCrudResourceContext()

    const handleOk = () => {
        store.confirm(
            { success: showSuccess, error: showError },
            () => crudContext?.actions?.reloadData?.(),
        )
    }

    return (
        <Modal
            title="Підтвердження виконання"
            open={store.open}
            onOk={handleOk}
            onCancel={() => store.close()}
            confirmLoading={store.loading}
            okText="Підтвердити"
            cancelText="Скасувати"
        >
            <div style={{ marginTop: 16 }}>
                {store.isCommentRequired() ? (
                    <>
                        <Text>Коментар диспетчера <span style={{ color: 'red' }}>*</span>:</Text>
                        <SimpleFormFieldCell
                            key={`confirm-modal-${store.open}`}
                            fieldName="comment"
                            fieldDef={{ type: 'textarea', inputProps: { rows: 3, placeholder: 'Введіть коментар...' } }}
                            initialValue=""
                            onChange={(val) => store.setComment(val ?? '')}
                        />
                        {store.commentError && <Text type="danger" style={{ fontSize: 12 }}>{store.commentError}</Text>}
                    </>
                ) : (
                    <Text>Підтвердити виконання завдання #{store.task?.id}?</Text>
                )}
            </div>
        </Modal>
    )
})
